var map = {
	"./brahminism-means-caste-supremacy.md": [
		2703,
		703
	],
	"./foes-robbed-us-of-our-saviour.md": [
		2627,
		627
	],
	"./forward.md": [
		3894,
		894
	],
	"./give-proof-of-your-affinity.md": [
		5272,
		272
	],
	"./good-rule-cannot-be-substitue-for-self-rule.md": [
		6732,
		732
	],
	"./late-shridhar-balwant-tilak.md": [
		2981,
		981
	],
	"./not-swaraj-but-rule-over-us.md": [
		6630,
		630
	],
	"./our-ascent-in-swaraj.md": [
		4825,
		825
	],
	"./parties-in-the-nation.md": [
		9885,
		885
	],
	"./progenitors-of-self-rule.md": [
		6075,
		75
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3859;
module.exports = webpackAsyncContext;